import i18n from 'i18next';
import { initReactI18next, I18nextProvider } from 'react-i18next';
import es from './es.json';
import en from './en.json';

i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
  },
  lng: localStorage.getItem('garaoke-lang') || 'es',
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false,
  },
});

export function I18nProvider({ children }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}

export default i18n;
